module.exports = __webpack_public_path__ + "img/carrousel-intervensionista-11.4960dd03.png";